import React, { useEffect, useRef, useState } from 'react';
import FilterBox from './SearchPageComponents/FilterBox';
import ResultsBox from './SearchPageComponents/ResultsBox';
import useUserData from 'hooks/useUserData';
import {
    loadSearchResultsCache,
    migrateSearchPersistence,
    saveSearchResultsCache,
} from 'utils/searchPersistence';

const SearchPage = () => {

    const [filters, setFilters] = useState({});
    const { userData } = useUserData();
    const userId = userData?.user_data?.id ?? null;

    // These states hold the search results and any error message
    const [results, setResults] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const restoredForUserRef = useRef(null);

    // If we used "anon" before userId was known, migrate it once.
    useEffect(() => {
        if (!userId) return;
        migrateSearchPersistence('anon', userId);
    }, [userId]);

    // Restore cached results (per-user) on mount and when userId becomes known.
    useEffect(() => {
        let cancelled = false;
        const key = userId ? String(userId) : 'anon';
        if (restoredForUserRef.current === key) return;
        if (results) {
            restoredForUserRef.current = key;
            return;
        }

        (async () => {
            const cached = await loadSearchResultsCache(key);
            if (!cancelled && cached) {
                setResults(cached);
            }
            restoredForUserRef.current = key;
        })();

        return () => {
            cancelled = true;
        };
    }, [userId, results]);

    // Persist latest results (per-user).
    useEffect(() => {
        if (!results) return;
        const key = userId ? String(userId) : 'anon';
        (async () => {
            await saveSearchResultsCache(key, results);
        })();
    }, [userId, results]);

    // Log the results to the console
    useEffect(() => {
        console.log('(Search page) Results:', results);
    }
    , [results]);

    useEffect(() => {
        console.log('(Search page) Error:', error);
    }
    , [error]);

    return ( 
            <div id="SearchPage" style={{
                display: "flex",
                alignItems: "center",
                height: "100vh",
                // paddingLeft: "50px",
            }}>
                <FilterBox 
                    userId={userId}
                    filters={filters}
                    setFilters={setFilters}
                    setLoading={setLoading}
                    setResults={setResults}
                    setError={setError}/>
                <ResultsBox loading={loading} results={results} error={error} userId={userId}/>
            </div>

     );
}
 
export default SearchPage;